import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Internet_Access/Videos/video-port-forwarding-tp-link";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};